import { gql } from '@common/hooks';
import { HistoryInfoFragment } from '@common/graphql';

const WorksListTemplatesQuery = gql`
  query WorksListTemplatesQuery {
    worksListTemplates {
      id
      name
      complianceDeadlineDetails
      canArchive {
        value
      }
    }
  }
`;

const WorksListTemplateQuery = gql`
  fragment WorksListItemTemplatesDetails on WorksListTemplate {
    id
    canArchive {
      value
    }
    worksListItemTemplates {
      id
      type
      name
      active
      description
      expirationType
      daysToExpiry

      ... on BackgroundIdentificationItemTemplate {
        documentTemplateSubtype
        documentTemplate {
          id
        }
      }
      ... on ImmigrationItemTemplate {
        documentTemplateSubtype
        documentTemplate {
          id
        }
      }
      ... on CertificationItemTemplate {
        certification {
          id
        }
      }
      ... on LicenseItemTemplate {
        licenseType
      }
      ... on AssessmentItemTemplate {
        assessmentIssuers {
          id
          name
        }
        assessment {
          id
          name
          category
        }
      }
      ... on HealthDocumentItemTemplate {
        healthDocSubtype
        seasonStartsAt
        seasonEndsAt
        healthDoc {
          id
        }
      }
    }
  }

  query WorksListTemplateQuery($id: ID!) {
    worksListTemplate(id: $id) {
      id
      name
      complianceDeadlineDetails
      bulkUpdateState
      activeAssignmentsCount

      history {
        ...HistoryInfoFragment
      }

      ...WorksListItemTemplatesDetails
    }
  }
  ${HistoryInfoFragment}
`;

const CreateWorksListTemplateMutation = gql`
  mutation CreateWorksListTemplateMutation(
    $input: CreateWorksListTemplateInput!
  ) {
    createWorksListTemplate(input: $input) {
      worksListTemplate {
        id
        name
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

const UpdateWorksListTemplateMutation = gql`
  mutation UpdateWorksListTemplateMutation(
    $input: UpdateWorksListTemplateInput!
    $worksListTemplateId: ID!
  ) {
    updateWorksListTemplate(
      worksListTemplateId: $worksListTemplateId
      input: $input
    ) {
      worksListTemplate {
        id
        name
        complianceDeadlineDetails
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

const BulkUpdateAssignmentListsFromTemplate = gql`
  mutation BulkUpdateAssignmentListsFromTemplate($id: ID!) {
    bulkUpdateAssignmentListsFromTemplate(id: $id) {
      worksListTemplate {
        id
        bulkUpdateState
      }
    }
  }
`;

const CloneWorksListTemplate = gql`
  mutation CloneWorksListTemplate($worksListTemplateId: ID!) {
    cloneWorksListTemplate(worksListTemplateId: $worksListTemplateId) {
      worksListTemplate {
        id
      }
    }
  }
`;

const WorksListTemplatesWithAssignmentRelatedQuery = gql`
  query WorksListTemplatesWithAssignmentRelatedQuery($id: ID!) {
    worksListTemplate(id: $id) {
      id
      name
      complianceDeadlineDetails

      changesSinceLastBulkUpdate {
        itemsAdded
        itemsInactivated
      }

      worksListsToBeBulkUpdated {
        id

        staffingRequestAssignment {
          id

          supplier {
            id
            name
          }

          organization {
            id
            name
          }

          organizationUnit {
            id
            name

            department {
              id

              organizationBusiness {
                id
                name
              }
            }
          }

          worksProfile {
            id
            fullName
          }
        }
      }
    }
  }
`;

export {
  WorksListTemplatesQuery,
  WorksListTemplateQuery,
  CreateWorksListTemplateMutation,
  UpdateWorksListTemplateMutation,
  CloneWorksListTemplate,
  BulkUpdateAssignmentListsFromTemplate,
  WorksListTemplatesWithAssignmentRelatedQuery,
};
